/* Mems DIY theme behaviour. No dependencies. */
(() => {
  const M = window.Mems || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const body = document.body;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const root = (M.routes.root || '/').replace(/\/$/, '');

  /* ---------- money (for predictive search, whose prices arrive as strings) ---------- */
  function formatMoney(amount) {
    const n = Number(amount);
    const fmt = M.moneyFormat || '£{{amount}}';
    const withDelims = (num, dp, th, dec) => {
      const [i, f] = num.toFixed(dp).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: withDelims(n, 2, ',', '.'),
      amount_no_decimals: withDelims(n, 0, ',', '.'),
      amount_with_comma_separator: withDelims(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelims(n, 0, '.', ','),
      amount_with_apostrophe_separator: withDelims(n, 2, "'", '.')
    }[k] ?? withDelims(n, 2, ',', '.')));
  }

  /* ---------- mega menu ---------- */
  const nav = $('nav.dept');
  if (nav) {
    let openId = null;
    const btns = $$('[data-mega]', nav);
    const open = id => {
      openId = id;
      $$('.mega', nav).forEach(p => p.classList.toggle('on', p.dataset.megaPanel === id));
      btns.forEach(b => b.setAttribute('aria-expanded', String(b.dataset.mega === id)));
    };
    const close = () => {
      openId = null;
      $$('.mega.on', nav).forEach(p => p.classList.remove('on'));
      btns.forEach(b => b.setAttribute('aria-expanded', 'false'));
    };
    // Click to open (no hover): a click on the open department, outside the menu, or Escape closes it.
    btns.forEach(b => b.addEventListener('click', () => (openId === b.dataset.mega ? close() : open(b.dataset.mega))));
    document.addEventListener('click', e => { if (openId && !nav.contains(e.target)) close(); });
    // keyboard users tabbing out of the menu
    nav.addEventListener('focusout', e => { if (e.relatedTarget && !nav.contains(e.relatedTarget)) close(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && openId) { const b = btns.find(x => x.dataset.mega === openId); close(); b && b.focus(); }
    });
  }

  /* ---------- mobile menu ---------- */
  const mnav = $('#mnav');
  const menuBtn = $('[data-menu-open]');
  const openMenu = () => { if (!mnav) return; mnav.hidden = false; mnav.classList.add('on'); body.style.overflow = 'hidden'; menuBtn && menuBtn.setAttribute('aria-expanded', 'true'); $('[data-menu-close]', mnav).focus(); };
  const closeMenu = () => {
    if (!mnav || mnav.hidden || mnav.classList.contains('closing')) return;
    const finish = () => { mnav.classList.remove('on', 'closing'); mnav.hidden = true; };
    if (reduceMotion) finish(); else { mnav.classList.add('closing'); setTimeout(finish, 200); }
    body.style.overflow = ''; menuBtn && menuBtn.setAttribute('aria-expanded', 'false'); menuBtn && menuBtn.focus();
  };
  menuBtn && menuBtn.addEventListener('click', openMenu);
  mnav && $('[data-menu-close]', mnav).addEventListener('click', closeMenu);

  /* ---------- predictive search ---------- */
  $$('form[data-predictive]').forEach(form => {
    const input = $('input[name=q]', form), box = $('.suggest', form);
    if (!input || !box || !M.routes.suggest) return;
    let timer, ctrl, hl = -1;
    const hide = () => { box.classList.remove('on'); input.setAttribute('aria-expanded', 'false'); hl = -1; };
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) return hide();
      ctrl && ctrl.abort(); ctrl = new AbortController();
      const url = `${M.routes.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,tag`;
      try {
        const r = await fetch(url, { signal: ctrl.signal });
        const d = (await r.json()).resources.results;
        const cols = (d.collections || []).slice(0, 4), prods = d.products || [];
        let html = '';
        if (cols.length) html += `<h4>${esc(M.strings.departments)}</h4>` + cols.map(c => `<a href="${esc(c.url)}" role="option">${esc(c.title)}</a>`).join('');
        if (prods.length) {
          html += `<h4>${esc(M.strings.products)}</h4>` + prods.map(p => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${esc(p.featured_image.url)}${p.featured_image.url.includes('?') ? '&' : '?'}width=80" alt="" width="40" height="40" loading="lazy">` : '';
            return `<a href="${esc(p.url)}" role="option">${img}<span>${esc(p.title)}</span><span class="pr">${formatMoney(p.price_min || p.price)}</span></a>`;
          }).join('');
          html += `<a href="${esc(M.routes.search)}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last" style="font-weight:700;color:var(--blue)">${esc(M.strings.seeAll)}</a>`;
        }
        box.innerHTML = html || `<p class="none">${esc(M.strings.noSuggestions.replace('__q__', q))}</p>`;
        box.classList.add('on'); input.setAttribute('aria-expanded', 'true'); hl = -1;
      } catch (e) { if (e.name !== 'AbortError') hide(); }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('keydown', e => {
      const items = $$('a', box);
      if (!box.classList.contains('on') || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        hl = (hl + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach((a, i) => a.classList.toggle('hl', i === hl));
        items[hl].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && hl > -1) { e.preventDefault(); location.href = items[hl].href; }
      else if (e.key === 'Escape') hide();
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) hide(); });
  });

  /* ---------- cart ---------- */
  const mainCart = () => $('[data-main-cart]');
  const sectionIds = () => ['cart-drawer', mainCart() && mainCart().dataset.sectionId].filter(Boolean).join(',');
  let lastFocus = null;
  function openCart() {
    lastFocus = document.activeElement;
    body.classList.add('cart-open');
    const d = $('#drawer'); d && setTimeout(() => d.focus(), 50);
  }
  function closeCart() {
    if (!body.classList.contains('cart-open')) return;
    body.classList.remove('cart-open');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function applySections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(`shopify-section-${id}`);
      const current = document.getElementById(`shopify-section-${id}`);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    });
    const d = $('#drawer');
    if (d) $$('[data-cart-count]').forEach(c => {
      if (c.textContent !== d.dataset.count) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
      c.textContent = d.dataset.count;
    });
  }
  async function cartPost(url, payload) {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...payload, sections: sectionIds(), sections_url: location.pathname }) });
    const d = await r.json();
    if (!r.ok || d.status) throw new Error(d.description || d.message || M.strings.cartError);
    applySections(d.sections);
    return d;
  }
  const addToCart = (id, quantity = 1, properties) => cartPost(`${M.routes.cartAdd}.js`, { items: [{ id: Number(id), quantity, ...(properties ? { properties } : {}) }] });
  const changeLine = (key, quantity) => cartPost(`${M.routes.cartChange}.js`, { id: key, quantity: Math.max(0, quantity) });
  window.MemsCart = { add: addToCart, change: changeLine, open: openCart, close: closeCart };

  document.addEventListener('click', async e => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && !e.metaKey && !e.ctrlKey) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      const label = add.textContent;
      add.disabled = true;
      try {
        await addToCart(add.dataset.add, Number(add.dataset.qty || 1));
        add.textContent = M.strings.added; add.classList.add('done');
        setTimeout(() => { add.textContent = label; add.classList.remove('done'); add.disabled = false; }, 1400);
        openCart();
      } catch (err) { add.disabled = false; alert(err.message); }
      return;
    }
    const line = e.target.closest('[data-line-key]');
    if (line && line.tagName === 'BUTTON') {
      e.preventDefault();
      line.disabled = true;
      try { await changeLine(line.dataset.lineKey, Number(line.dataset.qty)); } catch (err) { alert(err.message); line.disabled = false; }
    }
  });
  document.addEventListener('change', async e => {
    const i = e.target.closest('input[data-line-key]');
    if (!i) return;
    try { await changeLine(i.dataset.lineKey, Number(i.value) || 0); } catch (err) { alert(err.message); }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeCart(); closeMenu();
  });
  // keep focus inside the open drawer
  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab' || !body.classList.contains('cart-open')) return;
    const d = $('#drawer'); if (!d) return;
    const f = $$('a[href],button:not([disabled]),input', d);
    if (!f.length) return;
    if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === d)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', e => {
    const s = e.target.closest('[data-step]');
    if (!s) return;
    const input = $('input', s.closest('.qbox'));
    input.value = Math.max(Number(input.min || 1), (Number(input.value) || 1) + Number(s.dataset.step));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(sec => {
    const dataEl = $('script[data-product-json]', sec);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form.pform', sec);
    const idInput = form && $('input[name=id]', form);
    const addBtn = $('[data-add-button]', sec);
    const price = $('[data-price]', sec);
    const saleTag = $('[data-sale-tag]', sec);
    const mainImg = $('.gallery .main img', sec);
    const thumbs = $$('[data-thumb]', sec);

    const showMedia = id => {
      const t = thumbs.find(x => x.dataset.thumb === String(id));
      if (!t || !mainImg) return;
      mainImg.src = t.dataset.src; mainImg.srcset = t.dataset.srcset || ''; mainImg.alt = t.dataset.alt || '';
      thumbs.forEach(x => x.setAttribute('aria-current', String(x === t)));
    };
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

    const selected = () => $$('.opt', sec).map(o => { const b = $('button[aria-pressed=true]', o); return b ? b.dataset.value : null; });
    const update = () => {
      const opts = selected();
      const v = product.variants.find(x => x.options.every((o, i) => o === opts[i]));
      $$('.opt', sec).forEach((o, idx) => {
        $$('button', o).forEach(b => {
          const test = opts.slice(); test[idx] = b.dataset.value;
          const match = product.variants.find(x => x.options.every((val, i) => val === test[i]));
          b.classList.toggle('na', !match || !match.available);
        });
      });
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = M.strings.soldOut.toUpperCase(); } return; }
      if (idInput) idInput.value = v.id;
      if (price && v.price_html) price.innerHTML = v.price_html;
      if (saleTag) saleTag.hidden = !(v.compare_at_price > v.price);
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? M.strings.addToCart : M.strings.soldOut.toUpperCase(); }
      if (v.featured_media_id) showMedia(v.featured_media_id);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      sec.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
    };
    const choose = (o, value) => {
      $$('button[data-value]', o).forEach(x => x.setAttribute('aria-pressed', String(x.dataset.value === value)));
      const sel = $('select.valsel', o); if (sel) sel.value = value;
      update();
    };
    $$('.opt', sec).forEach(o => {
      o.addEventListener('click', e => { const b = e.target.closest('button[data-value]'); if (b) choose(o, b.dataset.value); });
      // long option lists use a dropdown on phones; it mirrors the buttons
      const sel = $('select.valsel', o);
      sel && sel.addEventListener('change', () => choose(o, sel.value));
    });
    if ($$('.opt', sec).length) update();

    form && form.addEventListener('submit', async e => {
      e.preventDefault();
      const qty = Math.max(1, Number($('input[name=quantity]', form)?.value) || 1);
      addBtn.disabled = true;
      try {
        await addToCart(idInput.value, qty);
        addBtn.textContent = M.strings.added; addBtn.classList.add('done');
        setTimeout(() => addBtn.classList.remove('done'), 1400);
        setTimeout(() => { addBtn.textContent = M.strings.addToCart; addBtn.disabled = false; }, 1400);
        openCart();
      } catch (err) { addBtn.disabled = false; alert(err.message); }
    });

    // recently viewed (this browser only)
    const rv = $('[data-recent]');
    try {
      const key = 'mems-rv';
      const list = (JSON.parse(localStorage.getItem(key) || '[]')).filter(h => h !== product.handle);
      localStorage.setItem(key, JSON.stringify([product.handle, ...list].slice(0, 8)));
      if (rv && list.length) {
        Promise.all(list.slice(0, 4).map(h => fetch(`${root}/products/${encodeURIComponent(h)}?section_id=product-card`).then(r => (r.ok ? r.text() : '')).catch(() => '')))
          .then(parts => {
            const html = parts.map(p => { const d = new DOMParser().parseFromString(p, 'text/html'); const a = d.querySelector('.pc'); return a ? a.outerHTML : ''; }).join('');
            if (html) { $('.grid', rv).innerHTML = html; rv.hidden = false; }
          });
      }
    } catch (e) { /* storage unavailable */ }
  });

  /* ---------- tabs ---------- */
  $$('[role=tablist]').forEach(list => {
    const tabs = $$('[role=tab]', list);
    const select = t => tabs.forEach(x => { const on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; select(n); n.focus();
      });
    });
    const pre = tabs.find(t => t.dataset.open === 'true' || ('#' + t.getAttribute('aria-controls')) === location.hash);
    if (pre) select(pre);
  });

  /* ---------- collection / search filters ---------- */
  function initFacets(scope = document) {
    const wrap = $('[data-facets]', scope);
    if (!wrap) return;
    const sectionId = wrap.dataset.sectionId;
    const form = $('form[data-facet-form]', wrap);
    const fbtn = $('[data-filter-toggle]', wrap), panel = $('#filters', wrap);
    fbtn && fbtn.addEventListener('click', () => { const o = panel.classList.toggle('open'); fbtn.setAttribute('aria-expanded', String(o)); });
    const go = async url => {
      wrap.setAttribute('aria-busy', 'true');
      try {
        const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
        const html = await (await fetch(u)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-facets]');
        if (!fresh) { location.href = url; return; }
        const open = panel && panel.classList.contains('open');
        wrap.replaceWith(fresh);
        const grid = $('.cgrid', fresh); grid && grid.classList.add('swapped');
        if (open) { $('#filters', fresh).classList.add('open'); $('[data-filter-toggle]', fresh)?.setAttribute('aria-expanded', 'true'); }
        history.pushState({ facets: true }, '', url);
        initFacets(fresh.parentElement);
      } catch (e) { location.href = url; }
    };
    const fromForm = () => {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd) if (v !== '') params.append(k, v);
      const sort = $('select[data-sort]', wrap);
      if (sort && sort.value) params.set('sort_by', sort.value);
      const per = $('select[data-per]', wrap);
      if (per && per.value) params.set('view', per.value);
      return `${location.pathname}?${params.toString()}`;
    };
    let t;
    form && form.addEventListener('change', e => {
      if (e.target.matches('input[type=number]')) { clearTimeout(t); t = setTimeout(() => go(fromForm()), 600); return; }
      go(fromForm());
    });
    form && form.addEventListener('submit', e => { e.preventDefault(); go(fromForm()); });
    const sortSel = $('select[data-sort]', wrap);
    sortSel && sortSel.addEventListener('change', () => go(fromForm()));
    // a different page size is a different template, so it needs a full page load
    const perSel = $('select[data-per]', wrap);
    perSel && perSel.addEventListener('change', () => { location.href = fromForm(); });
    wrap.addEventListener('click', e => {
      const a = e.target.closest('a[data-facet-link]');
      if (a) { e.preventDefault(); go(a.href); }
    });
  }
  initFacets();
  window.addEventListener('popstate', e => { if (e.state && e.state.facets) location.reload(); });

  /* ---------- images fade in as they load ---------- */
  const fadeImg = img => {
    if (img.dataset.fi || img.complete || img.closest('.hero')) return;
    img.dataset.fi = '1'; img.classList.add('fi');
    const done = () => img.classList.add('fi-in');
    img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
  };
  if (!reduceMotion) {
    $$('main img[loading=lazy], #drawer img').forEach(fadeImg);
    new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => {
      if (n.nodeType !== 1) return;
      if (n.tagName === 'IMG' && n.loading === 'lazy') fadeImg(n); else $$('img[loading=lazy]', n).forEach(fadeImg);
    }))).observe(body, { childList: true, subtree: true });
  }

  /* ---------- sections rise in as they scroll into view (Theme settings > Animations) ---------- */
  if (body.dataset.reveal === 'true' && !reduceMotion && !(window.Shopify && Shopify.designMode) && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('main > .shopify-section').forEach((sec, i) => {
      if (i === 0 || sec.getBoundingClientRect().top < innerHeight) return; // never hide what is already on screen
      sec.classList.add('reveal'); io.observe(sec);
    });
  }
})();
